import { Card, Flex, Tag, Text } from '@applyboard/crystal-ui'

type CurrentProgramSummaryCardProps = Readonly<{
  applicationSummary: {
    programName: string
    campusName: string
    intakeTermDate: string
  }
}>

export function CurrentProgramSummaryCard(props: CurrentProgramSummaryCardProps) {
  return (
    <Card variant="highlighted">
      <Flex direction="column" gap={2}>
        <Text variant="titleS">Your current selection:</Text>
        <Text>{props.applicationSummary.programName}</Text>
        <Flex direction="row" gap={2}>
          <Tag intent="primary" size="md">
            {props.applicationSummary.campusName}
          </Tag>
          <Tag intent="secondary" size="md">
            {props.applicationSummary.intakeTermDate}
          </Tag>
        </Flex>
      </Flex>
    </Card>
  )
}
